var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo__wrapper",class:{ campus: _vm.campusOnly },on:{"click":function($event){return _vm.toHome()}}},[(_vm.logoSrc)?_c('img',{staticClass:"logo-img",attrs:{"src":_vm.logoSrc,"contain":""}}):_c('h1',{staticClass:"logo-text single-line"},[_vm._v(_vm._s(_vm.campusName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }